import {createAction, props} from "@ngrx/store";
import {
  ViewDashboardCase,
  ViewDashboardCaseArchived,
  ViewDashboardCaseClosed,
  ViewDashboardCaseIncoming,
  ViewDashboardCaseOutgoing,
  ViewDashboardCaseRegionReport,
  ViewDashboardRegion
} from "@esa/api";
import {PagedResponse} from "../../models/paged-response";

//Get Dashboard Cases
export const getIncomingDashCaseFiles = createAction(
  '[CaseFiles] Get Incoming Dashboard CaseFiles',
  props<{ pageNumber: number, pageSize: number, searchTerm: string, caseStatus?: number, casePriority?: number, assignedUserId?: string, targetFiuId?: string, dateFrom?: string, dateTo?: string, isOverdue?: boolean }>()
)

export const getIncomingDashCaseSuccess = createAction(
  '[CaseFiles] Get Incoming Dashboard CaseFiles Success',
  props<{ incomingDashCaseFiles: ViewDashboardCaseIncoming[], incomingPagedResponse: PagedResponse }>()
)

export const getIncomingDashCaseError = createAction(
  '[CaseFiles] Get Incoming Dashboard CaseFiles Error',
)

//Get Dashboard Outgoing Cases
export const getOutgoingDashCaseFiles = createAction(
  '[CaseFiles] Get Outgoing Dashboard CaseFiles',
  props<{ pageNumber: number, pageSize: number, searchTerm: string, caseStatus?: number, casePriority?: number, assignedUserId?: string, targetFiuId?: string, dateFrom?: string, dateTo?: string, isOverdue?: boolean }>()
)

export const getOutgoingDashCaseSuccess = createAction(
  '[CaseFiles] Get Outgoing Dashboard CaseFiles Success',
  props<{ outgoingDashCaseFiles: ViewDashboardCaseOutgoing[], outgoingPagedResponse: PagedResponse }>()
)

export const getOutgoingDashCaseError = createAction(
  '[CaseFiles] Get Outgoing Dashboard CaseFiles Error',
)

//Get Dashboard Archived Cases
export const getArchivedDashCaseFiles = createAction(
  '[CaseFiles] Get Archived Dashboard CaseFiles',
  props<{ pageNumber: number, pageSize: number, searchTerm: string, caseStatus?: number, casePriority?: number, assignedUserId?: string, targetFiuId?: string, dateFrom?: string, dateTo?: string, isOverdue?: boolean }>()
)

export const getArchivedDashCaseSuccess = createAction(
  '[CaseFiles] Get Archived Dashboard CaseFiles Success',
  props<{ archivedCaseFiles: ViewDashboardCaseArchived[], archivedPagedResponse: PagedResponse }>()
)

export const getArchivedDashCaseError = createAction(
  '[CaseFiles] Get Archived Dashboard CaseFiles Error',
)

//Get Dashboard Active Cases
export const getActiveDashCaseFiles = createAction(
  '[CaseFiles] Get Active Dashboard CaseFiles',
  props<{ pageNumber: number, pageSize: number, searchTerm: string, caseStatus?: number, casePriority?: number, assignedUserId?: string, targetFiuId?: string, dateFrom?: string, dateTo?: string, isOverdue?: boolean }>()
)

export const getActiveDashCaseSuccess = createAction(
  '[CaseFiles] Get Active Dashboard CaseFiles Success',
  props<{ activeCaseFiles: ViewDashboardCase[], activePagedResponse: PagedResponse }>()
)

export const getActiveDashCaseError = createAction(
  '[CaseFiles] Get Active Dashboard CaseFiles Error',
)

//Get Dashboard Closed Cases
export const getClosedDashCaseFiles = createAction(
  '[CaseFiles] Get Closed Dashboard CaseFiles',
  props<{ pageNumber: number, pageSize: number, searchTerm: string, caseStatus?: number, casePriority?: number, assignedUserId?: string, targetFiuId?: string, dateFrom?: string, dateTo?: string, isOverdue?: boolean }>()
)

export const getClosedDashCaseSuccess = createAction(
  '[CaseFiles] Get Closed Dashboard CaseFiles Success',
  props<{ closedCaseFiles: ViewDashboardCaseClosed[], closedPagedResponse: PagedResponse }>()
)

export const getClosedDashCaseError = createAction(
  '[CaseFiles] Get Closed Dashboard CaseFiles Error',
)

export const getRegionCases = createAction(
  '[Regions] Get Dashboard Region Cases',
  props<{ timeframe: string }>()
)

export const getRegionCasesSuccess = createAction(
  '[Regions] Get Dashboard Region Cases Success',
  props<{ regionCases: ViewDashboardRegion[] }>()
)

export const getRegionCasesError = createAction(
  '[Regions] Get Dashboard Region Cases Error',
)

export const getRegionReport = createAction(
  '[Regions] Get Dashboard Regions Reports'
)

export const getRegionReportSuccess = createAction(
  '[Regions] Get Dashboard Region Reports Success',
  props<{ regionReport: ViewDashboardCaseRegionReport[] }>()
)

export const getRegionReportError = createAction(
  '[Regions] Get Dashboard Regions Reports Error'
)
